<template>
  <v-app>
    <component :is="activeNavMenu" :is-drawer-open.sync="isDrawerOpen"></component>

    <v-app-bar app flat absolute color="transparent">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon
            class="d-block d-lg-none me-2"
            @click="isDrawerOpen = !isDrawerOpen"
          ></v-app-bar-nav-icon>

          <v-spacer></v-spacer>
          <theme-switcher></theme-switcher>
          <!--          <v-menu-->
          <!--            offset-y-->
          <!--            left-->
          <!--            nudge-bottom="14"-->
          <!--            min-width="230"-->
          <!--            content-class="user-profile-menu-content"-->
          <!--          >-->
          <!--            <template v-slot:activator="{ on, attrs }">-->
          <!--              <v-btn icon small class="ms-3" v-bind="attrs" v-on="on">-->
          <!--                <v-badge-->
          <!--                  v-if="-->
          <!--                    driversNotification.count != 0 ||-->
          <!--                    complaintsNotification.count != 0 ||-->
          <!--                    studentsNotification.count != 0 ||-->
          <!--                    (studentsNeedBusAssignment.count != 0 &&-->
          <!--                      mode == 'simple') ||-->
          <!--                    (setSchoolAddress.count != 0 && mode == 'simple')-->
          <!--                  "-->
          <!--                  color="error"-->
          <!--                  :content="-->
          <!--                    driversNotification.count +-->
          <!--                    complaintsNotification.count +-->
          <!--                    studentsNotification.count +-->
          <!--                    (mode == 'simple' ? studentsNeedBusAssignment.count : 0) +-->
          <!--                    (mode == 'simple' ? setSchoolAddress.count : 0)-->
          <!--                  "-->
          <!--                >-->
          <!--                  <v-icon>-->
          <!--                    {{ icons.mdiBellOutline }}-->
          <!--                  </v-icon>-->
          <!--                </v-badge>-->

          <!--                <v-icon v-else>-->
          <!--                  {{ icons.mdiBellOutline }}-->
          <!--                </v-icon>-->
          <!--              </v-btn>-->
          <!--            </template>-->
          <!--            <v-list-->
          <!--              v-if="-->
          <!--                driversNotification.count != 0 ||-->
          <!--                complaintsNotification.count != 0 ||-->
          <!--                studentsNotification.count != 0 ||-->
          <!--                (studentsNeedBusAssignment.count != 0 && mode == 'simple') ||-->
          <!--                (setSchoolAddress.count != 0 && mode == 'simple')-->
          <!--              "-->
          <!--            >-->
          <!--              <v-list-item-->
          <!--                @click="viewDrivers"-->
          <!--                link-->
          <!--                v-if="driversNotification.count != 0"-->
          <!--              >-->
          <!--                <v-list-item-icon class="me-2">-->
          <!--                  <v-icon size="22">-->
          <!--                    {{ driversNotification.icon }}-->
          <!--                  </v-icon>-->
          <!--                </v-list-item-icon>-->
          <!--                <v-list-item-content>-->
          <!--                  <v-list-item-title>-->
          <!--                    {{ driversNotification.title }}-->
          <!--                  </v-list-item-title>-->
          <!--                </v-list-item-content>-->

          <!--                <v-list-item-action>-->
          <!--                  <v-badge-->
          <!--                    inline-->
          <!--                    color="error"-->
          <!--                    :content="driversNotification.count"-->
          <!--                  >-->
          <!--                  </v-badge>-->
          <!--                </v-list-item-action>-->
          <!--              </v-list-item>-->
          <!--              <v-divider v-if="driversNotification.count != 0"></v-divider>-->
          <!--              <v-list-item-->
          <!--                @click="viewStudents(2)"-->
          <!--                link-->
          <!--                v-if="studentsNotification.count != 0"-->
          <!--              >-->
          <!--                <v-list-item-icon class="me-2">-->
          <!--                  <v-icon size="22">-->
          <!--                    {{ studentsNotification.icon }}-->
          <!--                  </v-icon>-->
          <!--                </v-list-item-icon>-->
          <!--                <v-list-item-content>-->
          <!--                  <v-list-item-title>-->
          <!--                    {{ studentsNotification.title }}-->
          <!--                  </v-list-item-title>-->
          <!--                </v-list-item-content>-->

          <!--                <v-list-item-action>-->
          <!--                  <v-badge-->
          <!--                    inline-->
          <!--                    color="error"-->
          <!--                    :content="studentsNotification.count"-->
          <!--                  >-->
          <!--                  </v-badge>-->
          <!--                </v-list-item-action>-->
          <!--              </v-list-item>-->
          <!--              <v-divider v-if="studentsNotification.count != 0"></v-divider>-->
          <!--              <v-list-item-->
          <!--                @click="viewComplaints"-->
          <!--                link-->
          <!--                v-if="complaintsNotification.count != 0"-->
          <!--              >-->
          <!--                <v-list-item-icon class="me-2">-->
          <!--                  <v-icon size="22">-->
          <!--                    {{ complaintsNotification.icon }}-->
          <!--                  </v-icon>-->
          <!--                </v-list-item-icon>-->
          <!--                <v-list-item-content>-->
          <!--                  <v-list-item-title>-->
          <!--                    {{ complaintsNotification.title }}-->
          <!--                  </v-list-item-title>-->
          <!--                </v-list-item-content>-->

          <!--                <v-list-item-action>-->
          <!--                  <v-badge-->
          <!--                    inline-->
          <!--                    color="error"-->
          <!--                    :content="complaintsNotification.count"-->
          <!--                  >-->
          <!--                  </v-badge>-->
          <!--                </v-list-item-action>-->
          <!--              </v-list-item>-->

          <!--              <v-divider-->
          <!--                v-if="studentsNeedBusAssignment.count != 0 && mode == 'simple'"-->
          <!--              ></v-divider>-->
          <!--              <v-list-item-->
          <!--                @click="viewStudents(0)"-->
          <!--                link-->
          <!--                v-if="studentsNeedBusAssignment.count != 0"-->
          <!--              >-->
          <!--                <v-list-item-icon class="me-2">-->
          <!--                  <v-icon size="22">-->
          <!--                    {{ studentsNeedBusAssignment.icon }}-->
          <!--                  </v-icon>-->
          <!--                </v-list-item-icon>-->
          <!--                <v-list-item-content>-->
          <!--                  <v-list-item-title>-->
          <!--                    {{ studentsNeedBusAssignment.title }}-->
          <!--                  </v-list-item-title>-->
          <!--                </v-list-item-content>-->

          <!--                <v-list-item-action>-->
          <!--                  <v-badge-->
          <!--                    inline-->
          <!--                    color="error"-->
          <!--                    :content="studentsNeedBusAssignment.count"-->
          <!--                  >-->
          <!--                  </v-badge>-->
          <!--                </v-list-item-action>-->
          <!--              </v-list-item>-->

          <!--              <v-divider-->
          <!--                v-if="setSchoolAddress.count != 0 && mode == 'simple'"-->
          <!--              ></v-divider>-->
          <!--              <v-list-item-->
          <!--                @click="viewSchool"-->
          <!--                link-->
          <!--                v-if="setSchoolAddress.count != 0 && mode == 'simple'"-->
          <!--              >-->
          <!--                <v-list-item-icon class="me-2">-->
          <!--                  <v-icon size="22">-->
          <!--                    {{ setSchoolAddress.icon }}-->
          <!--                  </v-icon>-->
          <!--                </v-list-item-icon>-->
          <!--                <v-list-item-content>-->
          <!--                  <v-list-item-title>-->
          <!--                    {{ setSchoolAddress.title }}-->
          <!--                  </v-list-item-title>-->
          <!--                </v-list-item-content>-->

          <!--                <v-list-item-action>-->
          <!--                  <v-badge-->
          <!--                    inline-->
          <!--                    color="error"-->
          <!--                    :content="setSchoolAddress.count"-->
          <!--                  >-->
          <!--                  </v-badge>-->
          <!--                </v-list-item-action>-->
          <!--              </v-list-item>-->
          <!--            </v-list>-->
          <!--            <v-list v-else>-->
          <!--              <v-list-item>-->
          <!--                <v-list-item-title>No notifications</v-list-item-title>-->
          <!--              </v-list-item>-->
          <!--            </v-list>-->
          <!--          </v-menu>-->

          <app-locale></app-locale>

          <v-menu
            offset-y
            left
            nudge-bottom="14"
            min-width="230"
            content-class="user-profile-menu-content"
            z-index="1000"
          >
            <template v-slot:activator="{ on, attrs }">
              <button class="appbar-pill bell-pill ms-3" v-bind="attrs" v-on="on">
                <span v-if="notifications.lastNotificationsCount" class="bell-badge">
                  {{ notifications.lastNotificationsCount > 99 ? '99+' : notifications.lastNotificationsCount }}
                </span>
                <v-icon size="18" :color="notifications.lastNotificationsCount ? '#7B1FA2' : '#546E7A'">
                  {{ icons.mdiBellOutline }}
                </v-icon>
              </button>
            </template>
            <v-list v-if="notifications.lastNotifications.length > 0">
              <v-list-item
                link
                v-for="notification in notifications.lastNotifications"
                :key="notification.id"
                @click="viewAllNotifications"
              >
                <v-list-item-content>
                  <v-list-item-title class="notification-item">
                    <span v-if="notification.data.title">
                      {{ notification.data.title }}
                    </span>
                    <span v-else-if="notification.data.student.name">
                      {{ notification.data.student.name }}
                    </span>
                    -
                    <span class="notification-item-message">
                      {{ displayNotificationType(notification) }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>

                <!--                <v-list-item-action>-->
                <!--                  <v-badge inline color="error" :content="11"> </v-badge>-->
                <!--                </v-list-item-action>-->
              </v-list-item>
              <v-list-item link @click="viewAllNotifications">
                <v-list-item-content>
                  <v-list-item-title class="text-center">
                    {{ $t('navbar.all_notifications') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list v-else>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('navbar.no_notifications') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <app-bar-user-menu
            :admin-name="adminProfileStore.name"
            :admin-avatar="adminProfileStore.avatar"
            :admin-organisation-name="adminProfileStore.organisation_name"
            :profile-url="'/schools/view-profile/' + adminProfileStore.id"
            :admin="false"
          ></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <!--    <v-footer app inset color="transparent" absolute height="56" class="px-0">-->
    <!--      <div v-if="!activationStore.isActivated" class="boxed-container w-full">-->
    <!--        <div class="ml-auto">-->
    <!--          <v-btn-->
    <!--            color="error"-->
    <!--            size="x-large"-->
    <!--            elevated-->
    <!--            block-->
    <!--            depressed-->
    <!--            @click="$router.push('/activate-account')"-->
    <!--          >-->
    <!--            Please activate your account-->
    <!--          </v-btn>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </v-footer>-->

    <install-prompt></install-prompt>
  </v-app>
</template>

<script>
import { ref } from '@vue/composition-api';
import { mdiMagnify, mdiBellOutline, mdiGithub, mdiTranslate } from '@mdi/js';
import VerticalNavMenu from './components/vertical-nav-menu/SchoolVerticalNavMenu.vue';
import DirectorVerticalNavMenu from './components/vertical-nav-menu/DirectorVerticalNavMenu.vue';
import AuthService from '@/services/AuthService';
import ThemeSwitcher from './components/ThemeSwitcher.vue';
import AppBarUserMenu from './components/AppBarUserMenu.vue';
import { adminProfileStore } from '@/utils/helpers';
import { activationStore } from '@/utils/helpers';
import auth from '@/services/AuthService';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { Keys } from '@/config';
import AppLocale from './components/AppLocale/AppLocale.vue';
import InstallPrompt from './components/InstallPrompt.vue';
import notificationService from '@/services/NotificationService';
import { messaging } from '@/firebaseConfig';

export default {
  components: {
    InstallPrompt,
    VerticalNavMenu,
    DirectorVerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    AppLocale,
  },
  setup() {
    return { adminProfileStore, activationStore };
  },
  computed: {
    activeNavMenu() {
      return AuthService.getLoggedInUserRole() === 'director' ? DirectorVerticalNavMenu : VerticalNavMenu;
    },
  },
  data() {
    return {
      mode: null,
      driversNotification: {
        title: 'Drivers require review',
        icon: 'mdi-account-tie-hat',
        count: 0,
      },
      complaintsNotification: {
        title: 'Unresolved complaints',
        icon: 'mdi-comment-alert',
        count: 0,
      },
      studentsNotification: {
        title: 'Students require review',
        icon: 'mdi-badge-account-outline',
        count: 0,
      },
      studentsNeedBusAssignment: {
        title: 'Students need bus assignment',
        icon: 'mdi-bus-multiple',
        count: 0,
      },
      setSchoolAddress: {
        title: 'Set school address',
        icon: 'mdi-map-marker-path',
        count: 0,
      },
      secureKey: null,
      isDrawerOpen: true,
      // Icons
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
        mdiTranslate,
      },
      notifications: notificationService.state,
    };
  },
  created() {
    if (this.$vuetify.breakpoint.mdAndDown) {
      this.isDrawerOpen = false;
    }
    this.initPusher();
  },
  mounted() {
    this.mode = auth.getMode();
    notificationService.loadLastNotifications();

    // Rrjeta e sigurise: ngjarja live mund te humbase, dhe atehere zilja do
    // te mbetej e ngrire derisa perdoruesi ta rihapte faqen.
    this.pollNjoftimesh = window.setInterval(() => {
      notificationService.loadLastNotifications();
    }, 60000);
    this.loadNotifications();
    //load from server
    // window.setInterval(() => {
    //   this.loadNotifications();
    // }, 30000);
    this.requestPermission();
    this.listenForMessages();
  },
  beforeDestroy() {
    window.clearInterval(this.pollNjoftimesh);
  },
  methods: {
    loadNotifications() {
      axios.get('/notifications/all').then((response) => {
        this.complaintsNotification.count =
          response.data.unResolvedComplaintsCount;
        this.driversNotification.count = response.data.driversUnderReviewCount;
        this.studentsNotification.count =
          response.data.studentsUnderReviewCount;
        this.studentsNeedBusAssignment.count =
          response.data.studentsNeedBusAssignmentCount;
        this.setSchoolAddress.count = response.data.setSchoolAddressCount;
        this.adminProfileStore.name = response.data.adminName;
        this.adminProfileStore.avatar = response.data.adminAvatar;
        this.adminProfileStore.id = response.data.adminId;
        this.adminProfileStore.organisation_name =
          response.data?.adminOrganisation?.name;
        this.secureKey = response.data.secureKey;
        if (this.secureKey == null) {
          this.activationStore.isActivated = true; // Was false
        } else {
          this.activationStore.isActivated = true;
        }

        if (this.adminProfileStore?.id) {
          window.Echo.private(
            `App.Models.User.${this.adminProfileStore.id}`
          ).notification(() => {
            this.$notify({
              title: 'New notification',
              text: 'New notification. Please check all notifications',
              type: 'success',
            });
            notificationService.loadLastNotifications();
          });
        }
      });
    },
    viewDrivers() {
      localStorage.tabIdxDrivers = 2;
      this.$router.push('/drivers');
    },
    viewComplaints() {
      localStorage.tabIdxComplaints = 0;
      this.$router.push('/complaints');
    },
    viewStudents(tab) {
      localStorage.tabIdxStudents = tab;
      this.$router.push('/students');
    },
    viewSchool() {
      this.$router.push('/school');
    },
    initPusher() {
      window.Pusher = Pusher;

      const accessToken = localStorage.getItem('freshToken');
      if (!accessToken) return;

      window.Echo = new Echo({
        broadcaster: 'reverb',
        key: Keys.VUE_APP_REVERB_APP_KEY,
        wsHost: Keys.VUE_APP_REVERB_HOST,
        wsPort: Keys.VUE_APP_REVERB_PORT ?? 9090,
        wssPort: Keys.VUE_APP_REVERB_PORT ?? 443,
        forceTLS: (Keys.VUE_APP_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: `${Keys.VUE_APP_REVERB_SCHEME ?? 'https'}://${
          Keys.VUE_APP_REVERB_HOST
        }/broadcasting/auth`,
        auth: { headers: { Authorization: 'Bearer ' + accessToken } },
      });

      // if (this.adminProfileStore.id) {
      //   Echo.private(
      //     `App.Models.User.${this.adminProfileStore.id}`
      //   ).notification(() => {
      //     // toast.success('New notification. Please check all notifications');
      //     // getLastFiveUnRead();
      //   });
      // }
    },
    viewAllNotifications() {
      this.$router.push({ name: 'school-notifications' });
    },
    displayNotificationType(notification) {
      let message = '';
      if (notification?.type === 'App\\Notifications\\StudentTaken') {
        message = 'Student was taken';
      } else if (notification?.type === 'App\\Notifications\\StudentDropped') {
        message = 'Student was dropped';
      } else if (
        notification?.type === 'App\\Notifications\\MessageNotification'
      ) {
        message = notification?.data?.message;
      } else if (
        notification?.type === 'App\\Notifications\\PaymentNotification'
      ) {
        message =
          'Student paid for months: ' +
          notification?.data?.payment?.months?.join(', ');
      } else {
        message = '-';
      }

      return message;
    },
    async requestPermission() {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          messaging
            .getToken({
              vapidKey:
                'BCpFjiClOtuSlHXDHWWI0ZPoyRHGJHumPZ7Ly5cKpDh1qgN4d9hIgwT-HeJgr_eAkT0RS_WG3VVO4o_GV_th1yw',
            })
            .then((currentToken) => {
              if (currentToken) {
                axios.post('/notifications/store-token', {
                  fcm_token: currentToken,
                });
              } else {
                console.warn('No registration token available.');
              }
            })
            .catch((err) => {
              console.error('An error occurred while retrieving token. ', err);
            });
        }
      });
    },
    listenForMessages() {
      messaging.onMessage(messaging, () => {
        // Faqja eshte e hapur: FCM-ja e ka shfaqur tashme njoftimin, ndaj
        // ketu vetem rifreskohet zilja. Nje i dyte i krijuar me dore do te
        // dukej si dy njoftime per te njejtin veprim.
        notificationService.loadLastNotifications();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}

.notification-item {
  display: flex;
  align-content: center;
  gap: 4px;
}

.notification-item-message {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.bell-pill { position: relative; background: rgba(123,31,162,0.10) !important; }
.bell-pill:hover { background: rgba(123,31,162,0.20) !important; }
.theme--dark .bell-pill { background: rgba(186,104,200,0.16) !important; }
.theme--dark .bell-pill:hover { background: rgba(186,104,200,0.26) !important; }
.bell-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #E53935;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  border-radius: 8px;
  min-width: 16px;
  height: 16px;
  padding: 0 3px;
  line-height: 16px;
  text-align: center;
  pointer-events: none;
  z-index: 1;
}
</style>